import React from 'react';
import ImageSlider from './ImageSlider';
import AboutUs from './AboutUs';
import WhyUs from './WhyUs';
import ContactUs from './ContactUs';
import WhatsApp from './WhatsApp';
function Home() {
    document.title= 'Sky Computer Education | Home';
    return (
        <>
            <ImageSlider />
            <AboutUs />
            <WhyUs/>
            <ContactUs/>
            <WhatsApp/>

        </>
    )
}

export default Home
